import Button from "../../UI/Button";

export const ImportFilesConfirmation = ({
  total_rows,
  confirmation_text,
  onConfirm,
  onCancel,
}) => {

  return (
    <>
      <p className="mt-5">
        {total_rows} {confirmation_text}
      </p>
      <div className="mt-3 flex">
        <Button isPrimaryButton={true} onClick={onConfirm}>
          Yes
        </Button>
        <Button onClick={onCancel}>No</Button>
      </div>
    </>
  );
};
